import { isSubscriptionActive } from '@/lib/baba-api'
import { isSignedIn } from '@/lib/baba-auth'
import { useSubscriptionStatusQuery } from '../../store/babaApi'
import { usePaywall } from '../paywall'
import { useUsageSnapshot } from '../PlanMeter'
import { headerPlanView } from './planDisplay'

/**
 * Plan control for the translator header. Free accounts get a thin allowance
 * bar (bar only, numbers live in the accessible name) and one accent Upgrade
 * button; Pro and Pro+ get a small chip. Signed-out visitors get nothing here.
 * Usage comes from the same snapshot the rail card reads, so no extra request.
 */
export function HeaderPlan() {
  const signedIn = isSignedIn()
  const { open: openPaywall } = usePaywall()
  const { data: subscription } = useSubscriptionStatusQuery(undefined, { skip: !signedIn })
  const { used, limit } = useUsageSnapshot(signedIn)
  const isPro = subscription ? isSubscriptionActive(subscription) : false
  const view = headerPlanView({
    signedIn,
    subscriptionKnown: !!subscription,
    isPro,
    isProPlus: isPro && subscription?.tier === 'pro_plus',
    used,
    limit,
  })

  if (view.kind === 'none') return null

  if (view.kind === 'chip') {
    return (
      <span
        data-testid="header-plan-chip"
        className="shrink-0 rounded font-mono uppercase tracking-wider"
        style={{ fontSize: 10, lineHeight: '16px', padding: '0 6px', border: '1px solid var(--line)', background: 'var(--card-2)', color: 'var(--muted)' }}
      >
        {view.label}
      </span>
    )
  }

  return (
    <div className="flex items-center gap-3 min-w-0">
      <div className="hidden sm:flex flex-col gap-1 w-[140px] shrink-0" data-testid="header-allowance">
        <span className="text-[12px] leading-none" style={{ color: 'var(--muted)' }}>Free this month</span>
        <div
          role="progressbar"
          aria-label={view.ariaLabel}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(view.pct)}
          className="h-[6px] overflow-hidden rounded-full"
          style={{ background: 'var(--card-2)' }}
        >
          <div className="h-full rounded-full transition-all" style={{ width: `${view.pct}%`, background: view.atLimit ? 'var(--err)' : 'var(--accent)' }} />
        </div>
      </div>
      <button
        type="button"
        onClick={() => openPaywall('upgrade')}
        className="touch-44-y shrink-0 inline-flex items-center px-3 text-[13px] font-semibold whitespace-nowrap cursor-pointer select-none"
        style={{ minHeight: 44, borderRadius: 6, border: '1px solid var(--accent-deep)', background: 'var(--accent)', color: 'var(--cta-fg)' }}
      >
        Upgrade
      </button>
    </div>
  )
}
